<template>
    <section>
        <div class="search-save-button">
            <div class="search">
                <ds-input-field
                    v-model="searchCriteria"
                    class="search-input-field"
                    label="Search Custom fields"
                >
                    <template #trailing>
                        <span
                            v-show="searchCriteria"
                            class="clear-icon"
                            @click="clearSearch"
                        >
                            <ds-icon name="x" />
                        </span>
                    </template>
                </ds-input-field>
            </div>

            <contact-layout-custom-info-header :id="id" :contact-details="customFieldData" />
        </div>

        <div class="section-header">
            <h3>All custom fields</h3>
        </div>

        <div class="custom-fields-grid">
            <div v-for="(customFields, index) in customFieldData.customFields" :key="index" class="custom-fields-container">
                <contact-layout-custom-field-display
                    :id="id"
                    :custom-fields="customFields"
                    :search-criteria="searchCustomFields"
                    :header-display="headerDetails"
                    :header-details="{name: 'allcustomfields', id: 0}"
                />
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import ContactLayoutCustomFieldDisplay from './layout/ContactLayoutCustomFieldDisplay';
import ContactLayoutCustomInfoHeader from './ContactLayoutCustomInfoHeader';

export default {
    components: {
        ContactLayoutCustomFieldDisplay,
        ContactLayoutCustomInfoHeader,
    },

    props: {
        id: [String, Number],
    },

    data() {
        return {
            layoutDetails: [],
            customFieldData: {},
            fieldData: {},
            headerName: 'All custom fields',
            searchCriteria: '',
            headerDetails: { allcustomfields_0: true },
        };
    },

    created() {
        this.getCustomFieldDataByContactId();
    },

    computed: {
        searchCustomFields() {
            const searchField = this.searchCriteria?.replace(/\s+/g, '').toLowerCase();
            const headName = this.headerName?.replace(/\s+/g, '').toLowerCase();

            return headName?.includes(searchField) ? '' : this.searchCriteria;
        },
    },

    methods: {
        clearSearch() {
            this.searchCriteria = '';
        },

        async getCustomFieldDataByContactId() {
            const response = await axios.get(`/app/contact/layout/${this.id}`);

            this.customFieldData = response.data;
        },
    },
};
</script>
<style lang="scss" scoped>

.custom-fields-grid {
    --input-margin-bottom: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: $spacing-300;
}

@media screen and (max-width: 1200px) {
    .custom-fields-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media screen and ($small) {
    .custom-fields-grid {
        grid-template-columns: 1fr;
    }
}

.custom-fields-display {
    border-top: 1px solid $color-gray-lighter;
    margin-top: $spacing-250;
    padding: $spacing-400;
}

.custom-fields-group {
    display: flex;
    flex-direction: column;
    border-top: 1px solid $color-gray-lighter;
    margin-top: $spacing-200;
    padding-top: $spacing-300;
}

.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: $spacing-400;
    border-top: 1px solid $color-gray-30;
    padding-top: $spacing-300;
    margin-top: $spacing-200;
}

.custom-fields-container:empty {
    display: none;
}

.search-input-field {
    --input-margin-bottom: 0;
}

.search {
    width: px-to-rem(320px);
    --icon-color: #{$color-gray-600};
    margin-top: $spacing-200;
    justify-content: flex-start;
}

.clear-icon {
    --icon-color: #{$color-ink};
    cursor: pointer;
}

.search-save-button {
    justify-content: space-between;
    display: flex;
    margin-top: $spacing-200;
}
</style>
